import "./PartnerSlide.css";

const PartnerSlide = (props) => {
  return (
    <div className="partner-slide-container">
      <a href={props.url}>
        <img src={props.logoPath} alt={props.alt} className="partner-slide" />
      </a>
    </div>
  );
};
export default PartnerSlide;
